import React from 'react';
import DataList from './DataList';
import { getFormattedDate } from '../assets/Utils';
import { useAuth } from '../hooks/useAuth';

const DEFAULT_BASE_PAY = 1200;

const EmployeeList = () => {
    
   const { hasPermission } = useAuth();
   const canViewNassit = hasPermission('/employee-list/nassit', 'View');
   const syncSalary = (value, updatedFormData, setFormData, name) => {
     const base = Number(name === 'base_pay' ? value : updatedFormData.base_pay);
     const other = Number(name === 'other_entitlement' ? value : updatedFormData.other_entitlement);
     const total = (Number.isFinite(base) ? base : 0) + (Number.isFinite(other) ? other : 0);
     setFormData({
       ...updatedFormData,
       [name]: value,
       salary: Math.round(total * 100) / 100,
     });
   };
   const isMissingNassitNumber = (row) => {
     if (row.nassit_exempt) return false;
     return !String(row.nassit_ssn || '').trim();
   };

    const apiConfig = {
      title: 'Employees',
      path: '/employee-list',
      fetchEndpoint: '/hospital-portal/api/employees/all',
      createEndpoint: '/hospital-portal/api/employees',
      updateEndpoint: '/hospital-portal/api/employees',
      deleteEndpoint: '/hospital-portal/api/employees',
      defaultSortFieldId: 'hireDate',
      defaultSortAsc:false,
      allowAdd: true,
      allowEdit: true,
      allowExport: hasPermission('/employee-list', 'Export'),
      expandableRows: 'Off',
      dropdownFields: [
        {
          name: 'manager',
          endpoint: '/hospital-portal/api/employees',
          valueField: 'employee_id',
          labelField: 'employee_name',
        },
        {
            name: 'updatedBy',
            endpoint: '/hospital-portal/api/users',
            valueField: 'portal_id',
            labelField: 'name',
          },
      ],
      staticDropdownFields: [
        {
            name: 'role',
            options: [
                { id: 'Management', name: 'Management' },{ id: 'Pharmacist', name: 'Pharmacist' },
                { id: 'Driver', name: 'Driver' },{ id: 'Doctor', name: 'Doctor' },
                { id: 'Nurse', name: 'Nurse' },{ id: 'Lab Staff', name: 'Lab Staff' },
                { id: 'Supervisor', name: 'Supervisor' },{ id: 'Admin', name: 'Admin' },
                { id: 'Porter', name: 'Porter' },{ id: 'Night Cashier', name: 'Night Cashier' },
                { id: 'Lab Manager', name: 'Lab Manager' },{ id: 'Accountant', name: 'Accountant' },
                { id: 'Reception', name: 'Reception' },{ id: 'Pharmacy', name: 'Pharmacy' },
                { id: 'X-ray Staff', name: 'Xray Staff' },{ id: 'Logistics Staff', name: 'Logistics Staff' },
                { id: 'Cleaner', name: 'Cleaner' },{ id: 'Guardian', name: 'Guardian' },
                { id: 'HR', name: 'HR' },{ id: 'Electrician', name: 'Electrician' },
                { id: 'Technician', name: 'Technician' },{ id: 'CHO', name: 'CHO' },
                { id: 'Theatre Staff', name: 'Theatre Staff' },{ id: 'Guardian', name: 'Guardian' },
                { id: 'Cleaner', name: 'Cleaner' },{ id: 'Maintenance', name: 'Maintenance' },
                { id: 'Bikeman', name: 'Bikeman' },{ id: 'Other', name: 'Other' },
                
            ],
        },
        {
            name: 'branch',
            options:[
                { id: 'Poultney', name: 'Poultney'},
                { id: 'Kissy', name: 'Kissy'},

            ],
        },
        {
            name: 'salary_period',
            options:[
                { id: 'Monthly', name: 'Monthly'},
                { id: 'Monthly', name: 'Monthly'},

            ],
        },
        {
            name: 'sex',
            options: [
                { id: 'Female', name: 'Female' },
                { id: 'Male', name: 'Male' },
            ],
        },
        {
            name: 'department',
            options: [
                { id: 'Management', name: 'Management' },{ id: 'Pharmacy', name: 'Pharmacy' },
                { id: 'Driver', name: 'Transportation' },{ id: 'Medical', name: 'Medical' },{ id: 'Lab', name: 'Lab' },
                { id: 'Staff', name: 'Staff' },{ id: 'Cashier', name: 'Cashier' },{ id: 'Finance', name: 'Finance' },
                { id: 'Reception', name: 'Reception' },{ id: 'X-ray Staff', name: 'Xray Staff' },{ id: 'Logistics', name: 'Logistics' },
                { id: 'HR', name: 'HR' },{ id: 'Maintenance', name: 'Maintenance' },{ id: 'Other', name: 'Other' },
            ],
        },
        ],
      fields: [
        { name: 'employee_id', label:'Employee ID', type:'text', identifier:true, disabled:true,tab:'Employee' },
        {
          name: 'employee_name',
          label: 'Name',
          type: 'text',
          required: true,
          tab:'Employee',
          onChange: (value, updatedFormData, setFormData) => {
            const nassitName = String(updatedFormData.nassit_registered_name || '');
            const employeeName = String(value || '');
            const stillSynced = !nassitName.trim()
              || employeeName.startsWith(nassitName)
              || nassitName.startsWith(employeeName);
            if (stillSynced && nassitName !== employeeName) {
              setFormData({ ...updatedFormData, nassit_registered_name: employeeName });
            }
          },
        },
        { name: 'role', label: 'Role', type: 'dropdown', required:true,tab:'Employee' },
        { name: 'department', label: 'Department', type: 'dropdown', required:true,tab:'Employee' },
        { name: 'branch', label: 'Branch', type: 'dropdown', required:true,tab:'Employee' },
        { name: 'hire_date', label: 'Hire Date', type: 'date', required:true, defaultValue: getFormattedDate(),tab:'Employee' },
        { name: 'manager', label: 'Manager', type: 'dropdown',tab:'Employee' },
        { name: 'status', label: 'Status', type: 'checkbox',tab:'Employee' },
        { name: 'sex', label: 'Sex', type: 'dropdown', tab:'Employee' },
        { name: 'works_saturday', label: 'Works Saturday', type: 'checkbox', tab:'Employee', defaultValue: true },
        { name: 'base_pay', label: 'Base pay', type: 'number', tab:'Pay', defaultValue: DEFAULT_BASE_PAY, onChange: syncSalary },
        { name: 'other_entitlement', label: 'Other entitlements', type: 'number', tab:'Pay', defaultValue: 0, onChange: syncSalary },
        {
          name: 'salary',
          label: 'Salary',
          type: 'number',
          tab: 'Pay',
          disabled: true,
          onInitialize: (value, data) => {
            const base = Number(data.base_pay);
            const other = Number(data.other_entitlement);
            if (!Number.isFinite(base) && !Number.isFinite(other)) return value;
            const total = (Number.isFinite(base) ? base : 0) + (Number.isFinite(other) ? other : 0);
            return Math.round(total * 100) / 100;
          },
        },
        { name: 'annual_benefit_amount', label: 'Annual Benefit', type: 'number', tab:'Pay' },
        { name: 'salary_period', label: 'Salary Period', type: 'dropdown',tab:'Pay', defaultValue:'Monthly' },
        { name: 'bank_account', label: 'Bank Account', type: 'text', tab:'Pay' },
        { name: 'bank_name', label: 'Bank Name', type: 'text', tab:'Pay' },
        { name: 'nassit_exempt', label: 'NASSIT Exempt', type: 'checkbox', tab:'NASSIT', defaultValue: false },
        { name: 'nassit_ssn', label: 'NASSIT Number (17 characters)', type: 'text', tab:'NASSIT' },
        {
          name: 'nassit_registered_name',
          label: 'Name on NASSIT Card',
          type: 'text',
          tab:'NASSIT',
          onInitialize: (value, data) => {
            const savedName = (value == null || value === 'null') ? '' : String(value).trim();
            return savedName || data.employee_name || '';
          },
        },
        {name: 'createdAt', label: 'Date Created', type: 'text',tab:'Admin', disabled:true},
        {name: 'updatedAt', label: 'Date Updated', type: 'text',tab:'Admin', disabled:true},
        {name: 'updatedBy', label: 'Updated By', type: 'dropdown',tab:'Admin', disabled:true},

      ],
      tabs: [
        { name: 'Employee', securityPath: '/employee-list/employee', permission: 'View', default: true },
        { name: 'Pay', securityPath: '/employee-list/pay', permission: 'View' },
        { name: 'NASSIT', securityPath: '/employee-list/nassit', permission: 'View' },
        { name: 'Admin', securityPath: '/employee-list/admin', permission: 'View' },
      ],
      helperFiltersLabel: canViewNassit ? 'Missing NASSIT' : undefined,
      helperFilters: canViewNassit ? [
        { name: 'missingNassitNumber', label: 'No number', match: isMissingNassitNumber },
      ] : [],
    };
  
    const columns = [
      {
        name: 'Details',
        type: 'link',
        label: 'Details',
        path: '/employee-card',
        getState: (row) => ({ employee: row }),
      },
      { name: 'ID', selector: (row) => row.employee_id, sortable: true,identifier:true },  
      { name: 'Employee Name', selector: (row) => row.employee_name, sortable: true,filterable: true,filterSelector: 'employee_name' },
      { id: 'hireDate',name: 'Hire Date', selector: (row) => row.hire_date, sortable: true,type: 'date',filterable: true,filterSelector:'hire_date' },
      { name: 'Role', selector: (row) => row.role, sortable: true,filterable: true,filterSelector:'role' },
      { name: 'Branch', selector: (row) => row.branch, sortable: true, filterable: true, filterSelector: 'branch' },
      { name: 'Status', selector: (row) =>row.status, sortable: true, type: 'boolean',filterable: true,filterSelector:'status',filterDefault: 1,},
      ...(canViewNassit ? [
        {
          name: 'Base pay',
          selector: (row) => {
            const base = Number(row.base_pay);
            if (!Number.isFinite(base)) return '';
            return base;
          },
          sortable: true,
          right: true,
        },
        {
          name: 'NASSIT Number',
          selector: (row) => row.nassit_ssn || '',
          sortable: true,
        },
      ] : []),
    ];
  
    return <DataList apiConfig={apiConfig} columns={columns} />;
  };
  
  export default EmployeeList;